import axios from 'axios';

let url = '';

export const initTenantService = (config: Record<string, any>) => {
    url = config.rulesUrl;
};

type LandlordInfo = {
    tenant?: string;
    landlordId?: string;
    tenantName?: string;
    description?: string;
    allowTenantAccess: boolean;
    identityProviderId?: string;
    tenantAccess?: string;
};

type LandlordChecks = {
    isLandlord: boolean;
    hasLandlord: boolean;
    tenantWithLandlord: boolean;
};

export type GetLandlordInfo = LandlordChecks & LandlordInfo;

export const getLandlordInfo = async () => {
    const res = await axios.get<GetLandlordInfo>(`${url}/tenant/mapping/tenant`);
    const { data } = res;

    const isLandlord = data.tenant !== null && data.landlordId === null;
    const hasLandlord = data.tenant !== null && data.landlordId !== null;
    const tenantWithLandlord = !isLandlord && hasLandlord;

    return {
        ...res.data,
        isLandlord,
        hasLandlord,
        tenantWithLandlord
    };
};

export const getLandlordTenants = async () => {
    const res = await axios.get<Tenants>(`${url}/tenant/mapping`);
    return res.data;
};

export const getTenantGroupTenants = async (tenantGroupId: number) => {
    const res = await axios.get<GetTenantGroupTenantsAPIResponse>(`${url}/tenantGroups/${tenantGroupId}/tenant`);
    return res.data;
};

export const getUngroupedTenants = async () => {
    const res = await axios.get<Tenants>(`${url}/tenantGroups/ungrouped`);
    return res.data;
};

export const postTenantsToGroup = async (tenantGroupId: number, payload: PostTenantsToGroupPayload) => {
    const res = await axios.post<PostTenantsToGroupAPIResponse>(`${url}/tenantGroups/${tenantGroupId}/tenant`, payload);
    return res.data;
};

export const deleteTenantsFromGroup = async (tenantGroupId: number, payload: DeleteTenantsFromGroupPayload) => {
    return axios.delete(`${url}/tenantGroups/${tenantGroupId}/tenant`, { data: payload });
};

export const getRevisionTenantGroupOverrides = async (templateRepositoryId: number) => {
    const res = await axios.get<RevisionTenantGroupOverrides>(`${url}/tenantGroups/overrides`, {
        params: {
            templateRepositoryId
        }
    });
    return res.data;
};
